// extracted by mini-css-extract-plugin
module.exports = {"contents":"Mq-z","sectionHeading":"Nq-z"};